<template>
  <div>
    <div>
      <draggable
        class="list-group overflow-auto"
        tag="ul"
        v-model="subtasks"
        v-bind="dragOptions"
        handle=".handle"
        @change="updateSubtasksOrder"
        @start="drag = true"
        @end="drag = false"
      >
        <transition-group appear appear-class="custom-appear-class" type="transition" :name="'filters'" style="overflow: hidden">
          <div
            v-for="(subtask, index) in subtasks"
            :key="`subtask__${index}`"
          >
            <div
              v-if="subtask.status !== 'deleted'"
              :class="[subtask.status !== 'fuckingNew' ?  '': 'fakeTask']"
              class="row subtask animated pl-0 pr-0 pt-2 pb-2 m-0 unselectable animated">
              <div class="col-11">
                <i
                  v-if="subtask.status !== 'fuckingNew'"
                  :style="{'cursor': drag ? 'grabbing' : 'grab'}"
                  class="fe fe-menu mr-2 icons animated showIcon handle"></i>
                <i
                  v-else
                  style="cursor: not-allowed"
                  class="fe fe-menu mr-2 icons animated showIcon"></i>
                <i
                  @click="updateSubtask(subtask)"
                  :class="[subtask.status === 'done' ? 'fe-check-circle green' : 'fe-circle']"
                  class="fe mr-2 icons"
                  :style="{'cursor': subtask.status !== 'fuckingNew' ? 'pointer' : 'not-allowed'}"></i>
                <textarea-autosize
                  @keyup.native="updateSubtask(subtask, false, true)"
                  @keydown.enter.native.prevent="focusCreation"
                  :min-height="30"
                  v-model="subtask.name"
                  :ref="'mySubtask.' + subtask._id"
                  rows="1"
                  class="m-0 focus"
                ></textarea-autosize>
              </div>
              <div class="col-1">
                <i
                  @click="updateSubtask(subtask, true)"
                  :style="{'cursor': subtask.status !== 'fuckingNew' ? 'pointer' : 'not-allowed', 'color': subtask.status !== 'fuckingNew' ? '#E43A5A' : ''}"
                  class="fe fe-trash-2 icons animated showIcon float-right pr-2"></i>
              </div>
            </div>
          </div>
        </transition-group>
      </draggable>
      <div class="row subtask pl-0 pr-0 pt-2 pb-2 m-0 unselectable" v-if="!loading">
        <div class="col-12">
          <i
            class="fe fe-menu mr-2 icons animated showIcon handle"></i>
          <textarea-autosize
            @keydown.enter.native.prevent="createNewSubtask"
            :min-height="30"
            v-model="newSubtaskTitle"
            :placeholder="$t('common.edit_task.set_subtask_name')"
            ref="creation"
            rows="1"
            class="m-0 focus"
          ></textarea-autosize>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <loader-element></loader-element>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import LoaderElement from '../../../components/base/elements/Loader.element';

  export default {
    name: 'Subtasks',
    computed: {
      dragOptions () {
        return {
          animation: 200,
          group: 'subtask',
          disabled: false,
          ghostClass: 'ghost',
        };
      },
    },
    data () {
      return {
        subtasks: [],
        loading: false,
        drag: false,
        newSubtaskTitle: '',
      };
    },
    props: {
      task: {
        default: function () {
          return {};
        },
      },
    },
    watch: {
      task: function (newTask) {
        this.getSubtasks(newTask._id);
      },
    },
    components: {
      draggable,
      LoaderElement,
    },
    methods: {
      getSubtasks (taskId) {
        this.loading = true;
        this.$api().get(`tasks/${taskId}/info?token=${localStorage.getItem('token')}`)
          .then((response) => {
            this.subtasks = response.data.payload.sub_tasks.sort((a, b) => (a.order - b.order));
            this.loading = false;

            this.$nextTick(() => {
              for (const area in this.$refs) {
                if (area.startsWith('mySubtask')) {
                  this.$refs[area][0].$el.focus();
                }
              }
            });
          });
      },
      updateSubtasksOrder () {
        const taskIds = [];
        for (let i = 0; i < this.subtasks.length; i++) {
          taskIds.push(this.subtasks[i]._id);
        }

        this.$store.dispatch('updateTasksOrder', taskIds);
      },
      updateSubtask (subtask, deleted = false, status = false) {
        if (subtask.status === 'fuckingNew') {
          return 0;
        }
        if (!status) {
          subtask.status = deleted ? 'deleted' : subtask.status === 'done' ? 'new' : 'done';
        }
        const task = Object.assign(subtask, { token: localStorage.getItem('token') });
        if (!task.deadline_date) {
          task.deadline_date = null;
        }
        if (!task.plan_date) {
          task.plan_date = null;
        }
        this.$socket.emit('server_update_task', task);
      },
      createNewSubtask () {
        if (!this.newSubtaskTitle) {
          return false;
        }
        const fakeId = Date.now() + '';
        const fuckingFakeSubtask = {
          _id: fakeId,
          name: this.newSubtaskTitle,
          status: 'fuckingNew',
        };

        this.subtasks.push(fuckingFakeSubtask);

        const newSubtask = {
          name: this.newSubtaskTitle,
          parent_task_id: this.task._id,
          company_id: this.task.company_id,
          project_id: this.task.project_id,
        };
        this.$api().post('/tasks/create', { task: JSON.stringify(newSubtask) }, {
          params: { token: localStorage.getItem('token') },
        })
          .then((response) => {
            if (response.data.ok) {
              for (const sub of this.subtasks) {
                if (sub._id === fakeId) {
                  sub.status = response.data.payload.status;
                  sub._id = response.data.payload._id;
                  break;
                }
              }
            } else {
              this.$app.$noty.error('An Error occurred: ' + response.data.error);
            }
          });
        setTimeout(() => {
          this.newSubtaskTitle = '';
        }, 0);
      },
      focusCreation () {
        this.$refs.creation.$el.focus();
      },
    },
    mounted () {
      this.getSubtasks(this.task._id);
    },
  };
</script>

<style scoped>
  .green {
    color: #35A666 !important;
  }

  .animated {
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -ms-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }

  .animated:hover {
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -ms-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
    background-color: #F8F9FC;
  }

  .fakeTask {
    opacity: 0.6;
  }

  .subtask {
    font-size: 1.2em;
    color: #000000;
    text-shadow: 0 0.5px gainsboro;
    border-radius: 6px;
  }

  input, textarea {
    background-color: inherit;
    border: 0px;
    width: 86%;
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    font-size: 15px;
  }

  textarea::placeholder {
    color: #6F85A2;
  }

  .icons {
    color: #96ABC8
  }

  .showIcon {
    opacity: 0;
  }

  .animated:hover .showIcon {
    opacity: 1;
  }

  /*Transition-group style*/
  .filters-enter-active, .filters-leave-active {
    transition: .5s ease-in-out;
  }
  .filters-enter, .filters-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }
  .filters-enter-to, .filters-leave /* .fade-leave-active до версии 2.1.8 */ {
    max-height: 150px;
  }
</style>
